import React from 'react';
import { useSonTranslation } from '../../../../../translation/useSonTranslation';
import { ButtonRefType } from '../../../../../components/molecules/Btn/Btn';
import {
  ButtonIconActionConfirm,
  ButtonIconActionDecline,
} from '../../../../../components/molecules/Btn/ButtonWrapper';

type AcceptDeclineFormButtonsProps = {
  acceptButtonRef: ButtonRefType | undefined;
  declineButtonRef: ButtonRefType | undefined;
  buttonAriaDisabled: boolean;
  onDecline?: () => void;
};

export function AcceptDeclineFormButtons({
  acceptButtonRef,
  declineButtonRef,
  buttonAriaDisabled,
  onDecline,
}: AcceptDeclineFormButtonsProps) {
  const { t } = useSonTranslation('glossary');

  return (
    <div className="accept-decline-form__buttons">
      <ButtonIconActionConfirm
        reference={acceptButtonRef}
        text={t('yes')}
        type="submit"
        ariaDisabled={buttonAriaDisabled}
      />
      <ButtonIconActionDecline
        reference={declineButtonRef}
        text={t('no')}
        type="button"
        onClick={onDecline}
        ariaDisabled={buttonAriaDisabled}
      />
    </div>
  );
}
